var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ef3731;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24,
    rx: 3.05,
    ry: 3.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.4,8.14c0-1.01.82-1.84,1.84-1.84h.46c.34,0,.61.27.61.61s-.27.61-.61.61h-.46c-.34,0-.61.27-.61.61v3.06c0,1.69,1.37,3.06,3.06,3.06s3.06-1.37,3.06-3.06v-3.06c0-.34-.27-.61-.61-.61h-.46c-.34,0-.61-.27-.61-.61s.27-.61.61-.61h.46c1.01,0,1.84.82,1.84,1.84v3.06c0,2.16-1.6,3.94-3.67,4.24v.04c0,1.69,1.37,3.06,3.06,3.06,1.52,0,2.77-1.1,3.02-2.55.06-.33.37-.56.7-.5s.56.37.5.7c-.34,2.03-2.1,3.57-4.22,3.57-2.37,0-4.28-1.92-4.28-4.28v-.04c-2.08-.3-3.67-2.08-3.67-4.24v-3.06ZM17.03,14.25c1.01,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigns);
export default __webpack_public_path__ + "static/media/signs.1281be43790fbec200d3ddcdba1a6f07.svg";
export { ForwardRef as ReactComponent };